import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Info from '../icons/Info';
import css from './ToolTip.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ToolTip = function ToolTip(_ref) {
  var id = _ref.id,
      text = _ref.text;
  var tooltipRef = useRef(null);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = useState(text),
      _useState4 = _slicedToArray(_useState3, 2),
      tip = _useState4[0],
      setTip = _useState4[1];

  useEffect(function () {
    var current = tooltipRef.current;

    var closeTooltip = function closeTooltip() {
      setOpen(false);
      setTimeout(function () {
        setTip(''); // Remove so that live area status can update
      }, 250);
      setTimeout(function () {
        setTip(text); // Reset so that text remains visible on hover
      }, 500);
    };

    var toggleTooltip = function toggleTooltip() {
      if (open) {
        closeTooltip();
      } else {
        setTimeout(function () {
          setTip("".concat(text, " ")); // Added space so live area status can update

          setOpen(true);
        }, 250);
      }
    };

    var onKeyDown = function onKeyDown(event) {
      var ENTER = KEY_CODES.ENTER,
          ESC = KEY_CODES.ESC,
          TAB = KEY_CODES.TAB;

      switch (event.key) {
        // Toggle tooltip when user presses ENTER
        case ENTER:
          toggleTooltip();
          break;
        // Close tooltip when user presses ESC or TABs out

        case ESC:
        case TAB:
          closeTooltip();
      }
    };

    current.addEventListener(KEY_DOWN, onKeyDown);
    return function () {
      current.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [open, tooltipRef]);
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("div", {
      "aria-controls": "".concat(id, "-tip"),
      className: cc([css.tooltip, _defineProperty({}, css.open, open), css['focus-visible']]),
      id: id,
      tabIndex: 0 // eslint-disable-line jsx-a11y/no-noninteractive-tabindex
      ,
      ref: tooltipRef,
      role: "tooltip",
      children: /*#__PURE__*/_jsx(Info, {})
    }), /*#__PURE__*/_jsx("p", {
      className: css.tip,
      id: "".concat(id, "-tip"),
      "aria-hidden": !open,
      "aria-live": "polite",
      role: "status",
      children: tip
    })]
  });
};

ToolTip.propTypes = {
  id: PropTypes.string.isRequired,
  // ADA requires unique roles/IDs
  text: PropTypes.string.isRequired
};
export default ToolTip;